import {
	type ChangeEvent,
	ChangeEventTypes,
} from '@atlassian/jira-issue-view-model/src/change-type.tsx';
import type { Card } from '../../model/types.tsx';
import { loadAppData } from '../../state/actions/app/index.tsx';
import { isCMPScrumBacklog, getSprintFieldId } from '../../state/selectors/app/index.tsx';
import type { Action, State } from '../../state/types.tsx';
import { updateRankOnChildrenOrderChange } from './utils.tsx';

export const mapResponseToIssue = (
	issue: Card | null,
	state: State,
	payload: ChangeEvent,
): Action | null => {
	if (!payload.type || !issue) {
		return null;
	}

	// TODO: To be added when Backlog supports issue children (CATBUS-2200)
	// if (payload.type === ChangeEventTypes.ISSUE_CHILDREN_ORDER_CHANGED) {
	//     return setIssueChildrenRank(payload.meta);
	// }

	if (payload.type === ChangeEventTypes.FIELD_CHANGED) {
		const isCMPScrum = isCMPScrumBacklog(state);
		const sprintFieldId = getSprintFieldId(state);
		if (isCMPScrum && payload.meta.fieldId === sprintFieldId) {
			return loadAppData();
		}
	}

	if (
		payload.type === ChangeEventTypes.SUBTASK_ADDED ||
		payload.type === ChangeEventTypes.CHILD_ISSUE_ADDED
	) {
		return loadAppData();
	}

	if (payload.type === ChangeEventTypes.ISSUE_CHILDREN_ORDER_CHANGED) {
		return updateRankOnChildrenOrderChange(state, payload.meta);
	}

	return null;
};
